import React from "react";
import StorySectionStyle from "../../../components/Sections/StorySectionStyle";
import { Box } from "@mui/material";
import { APP_COLORS } from "../../../utils/constants";
import Form from "./Form";

const Description = () => {
  return <Form />;
};

const storySection = {
  title: "Schedule a meeting",
  content: <Description />,
  description: (
    <>
      Please fill out the form and we will be in touch with you within five
      business days. <br />
      Thank You!
    </>
  ),
};
export default function ScheduleSection({ id }) {
  return (
    <Box sx={{ py: "3.5rem", backgroundColor: APP_COLORS.MAIN_LIGHT }}>
      <StorySectionStyle
        section={storySection}
        id={id}
        bgColor={APP_COLORS.MAIN_LIGHT}
      />
    </Box>
  );
}
